// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NzH5r","controls":"styles_controls__2d6iz","charLimit":"styles_charLimit__1Qjav","input":"styles_input__2EIkg","send":"styles_send__1_DSS"};